export enum UserRoleEnum {
  ALWAYS_ALLOWED = "ALL",
  ADMIN = "Admin",
  SECRETARY = "Secretaria",
  READ = "Leitura",
  AUX_SECRETARY = "Aux. Secretaria",
  ROUTINE = "Rotina",
  YOUTH = "Jovens",
  AUX_YOUTH = "Aux. Jovens",
  AUX_CAMPAIGN = "Aux. Campanha",
  TEACHER = "Professor",
  FINANCE = "Financeiro",
  STUDENT = "Aluno"
}